import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useXyqarAuth } from '@xyqar/shared-auth';
import { apiGet, apiPost } from '../lib/api';
import { PageTitle, Card, Btn } from '../components/ui-kit';

interface Entry { date: string; hours: number; comment: string; }

export default function MissionCRA() {
  const { id } = useParams();
  const { getToken } = useXyqarAuth();
  const [entries, setEntries] = React.useState<Entry[]>([]);
  const [adding, setAdding] = React.useState<Entry>({ date: new Date().toISOString().slice(0, 10), hours: 7, comment: '' });
  const [msg, setMsg] = React.useState<string | null>(null);

  React.useEffect(() => {
    (async () => {
      try { const tok = await getToken().catch(() => ''); const j = await apiGet<{ entries: Entry[] }>(`/api/v1/expert/missions/${id}/cra`, tok); setEntries(j.entries ?? []); }
      catch { /* */ }
    })();
  }, [id, getToken]);

  const add = () => { setEntries((e) => [...e, adding]); setAdding({ date: adding.date, hours: 7, comment: '' }); };

  const submit = async () => {
    setMsg(null);
    try {
      const tok = await getToken().catch(() => '');
      await apiPost(`/api/v1/expert/missions/${id}/cra`, { entries }, tok);
      setMsg('CRA submitted to client for approval.');
    } catch (e: any) { setMsg(`Error: ${e.message}`); }
  };

  const total = entries.reduce((s, e) => s + (Number(e.hours) || 0), 0);
  const inp = 'rounded-md bg-white/5 border border-white/10 px-3 py-2 text-sm text-white focus:outline-none focus:border-white/40';

  return (
    <div>
      <PageTitle kicker={`Mission · ${id}`} title="Submit CRA" />
      <Card className="mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
          <input type="date" className={inp} value={adding.date} onChange={(e) => setAdding({ ...adding, date: e.target.value })} />
          <input type="number" className={inp} placeholder="hours" value={adding.hours} onChange={(e) => setAdding({ ...adding, hours: Number(e.target.value) })} />
          <input className={`${inp} sm:col-span-2`} placeholder="Comment (optional)" value={adding.comment} onChange={(e) => setAdding({ ...adding, comment: e.target.value })} />
        </div>
        <div className="flex justify-end mt-3"><Btn onClick={add}>+ Add line</Btn></div>
      </Card>

      <Card>
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-mono"><tr><th className="text-left py-3">Date</th><th className="text-right py-3">Hours</th><th className="text-left py-3 pl-6">Comment</th></tr></thead>
          <tbody>
            {entries.length === 0 && <tr><td colSpan={3} className="py-8 text-center text-white/40">No entries — add lines above.</td></tr>}
            {entries.map((e, i) => (
              <tr key={i} className="border-t border-white/5"><td className="py-3 font-mono">{e.date}</td><td className="py-3 text-right">{e.hours}h</td><td className="py-3 pl-6 text-white/60">{e.comment || '—'}</td></tr>
            ))}
          </tbody>
          <tfoot><tr className="border-t border-white/15"><td className="py-3 text-white/40 text-xs uppercase tracking-wider">Total</td><td className="py-3 text-right font-bold">{total}h</td><td /></tr></tfoot>
        </table>
        {msg && <p className="text-xs text-white/60 mt-4">{msg}</p>}
        <div className="flex justify-end mt-6"><Btn primary onClick={submit} disabled={entries.length === 0}>Submit to client →</Btn></div>
      </Card>
    </div>
  );
}
